import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  MarketingConsent,
  NcbConsent,
  Consent,
  IApplicaiton,
  CustomerDetail,
  ILoanOffers,
} from '../../interfaces';

import { environment } from '@environments/environment';
import { AppStateService } from '../../../app-state.service';
import { HttpService } from '@web-di-ld/apps/http';

// service
@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  constructor(
    private httpClient: HttpClient,
    public appState: AppStateService,
    public httpService: HttpService
  ) {}

  getMarketConsent(): any {
    return (
      this.httpService
        // .get<Province>(`assets/data/lookup/province.json`)
        .get<MarketingConsent>(
          `/api/applications/v1/applications/model-consent`
        )
        .toPromise()
        .then((response: any) => {
          return response;
        })
        .catch((error) => {
          this.handleError(error);
          return [];
        })
    );
  }

  postNcbConsent(customerDetail: CustomerDetail): any {
    return this.httpService
      .post(`/api/applications/v1/applications/consent-ncb-draft`, {
        titleTh: customerDetail.titleTh,
        firstNameTh: customerDetail.firstNameTh,
        surnameTh: customerDetail.surnameTh,
        custBirthDate: customerDetail.dateOfBirth,
        mobileNumber: customerDetail.mobileNumber,
        campaignId: this.getStateLoanOffers().campaignId,
      })
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        this.handleError(error);
        return [];
      });
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }

  getStateConsent(): any {
    // console.log(
    //   'getStateConsent :',
    //   this.appState.snapshot.application.consent
    // );
    return this.appState.snapshot.application.consent;
  }

  getStateStatePersonalInformation(): any {
    return this.appState.snapshot.personalInformation;
  }

  getStateLoanApplication(): any {
    return this.appState.snapshot.loanApplication;
  }

  getStateLoanOffers(): ILoanOffers {
    return this.appState.snapshot.loanOffers;
  }

  updateConsent(consent: Consent) {
    this.appState.updateStateConsent(consent);
  }

  saveApplicaiton(application: IApplicaiton) {
    return this.httpService
      .post(`/lfm-applications/app/v1/application/save`, application, false)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
        return null;
      });
  }
}
